import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { GreyPage } from './grey';

@NgModule({
  declarations: [
    GreyPage,
  ],
  imports: [
    IonicPageModule.forChild(GreyPage),
  ],
})
export class GreyPageModule {}



// WEBPACK FOOTER //
// ./src/app/shared/grey/grey.module.ts